import React, {useState, useRef, useEffect} from 'react';
import Button from '@material-ui/core/Button';
import TextEditor from './TextEditor';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import AdminPanelSettingsIcon from '@material-ui/icons/Edit';
import {connect} from 'react-redux';

function Explanation_text(props){
  const[edit_text, setEditText]=useState(false);
  const[current_text, setCurrentText]=useState(undefined);
  let main_container=useRef();


  let styles={
    'small_title':{fontWeight:'bold', fontSize:'14px'},
    'bold_caption':{fontWeight:'bold'}
  }

  useEffect(()=>{
    if(main_container && main_container.current){
      for(let a of main_container.current.getElementsByTagName('a')){
        a.addEventListener('click', function(e){e.preventDefault(); e.stopPropagation(); let item=e.target; if(item.href==undefined){item=item.parentNode; if(item.href==undefined){item=item.parentNode; if(item.href==undefined){item=item.parentNode; }}} open(item.href, 'help_box', 'height='+window.outerHeight+', width='+window.screenX+', top='+window.screenY+', left=0')});
      }
  }else{
    window.setTimeout(function(){
      if(main_container && main_container.current){
        for(let a of main_container.current.getElementsByTagName('a')){
          a.addEventListener('click', function(e){e.preventDefault(); e.stopPropagation(); let item=e.target; if(item.href==undefined){item=item.parentNode; if(item.href==undefined){item=item.parentNode; if(item.href==undefined){item=item.parentNode; }}} open(item.href, 'help_box', 'height='+window.outerHeight+', width='+window.screenX+', top='+window.screenY+', left=0')});
        }
    }
    }, 3000);
  }
},[]);

  function submitText(){
    if(current_text!=undefined){props.changeAdminText({text_key:props.text, text:current_text});}
    setEditText(false);
  }

  function placeholders(text, inline){
    for(let k in props.placeholders){
      let key="["+k+"]"
      text=text.replace(key, props.placeholders[k]);
    }
    if(inline==true){text=text.replace('<div>', '<span>').replace('</div>','</span>');}
    return text;
  }
  let style={}
  let variant=undefined;
  if(props.style=='bold_caption'){variant='caption'}
  if(props.variant!=undefined){variant=props.variant}
  if(props.style!=undefined && styles[props.style]!=undefined){style=styles[props.style]}

  if(props.text_array==undefined || props.text_array=='loading'){return null;}
  if(props.text_array[props.text]==undefined){
    if(props.inline==true){return (<span style={{position:'relative', display:'inline-block'}}>{props.text}</span>)}
    return(
    <Typography ref={main_container} variant={variant} color={props.color} style={{...style}}>{props.text}</Typography>
  )}
  if(props.me!=undefined && props.me.super_admin==true){
    if(edit_text==false){
      if(props.inline==true){return (<span id='main_container' onDoubleClick={()=>{setEditText(true);}} dangerouslySetInnerHTML={{__html:(props.text_array[props.text]==undefined)?'... ... ...':placeholders(props.text_array[props.text], true)}}/>)}
      return(<span><Typography ref={main_container} variant={variant} onDoubleClick={()=>{setEditText(true);}} color={props.color} style={{position:'relative', ...style}}><span dangerouslySetInnerHTML={{__html:(props.text_array[props.text]==undefined)?'... ... ...':placeholders(props.text_array[props.text])}} /></Typography></span>);
    }else{
      return(<div>
          <TextEditor style={{width:'calc(100% - 40px)', marginLeft:'20px', zIndex:'10000000'}} value={(current_text==undefined && props.text_array[props.text]!=undefined)?props.text_array[props.text]:current_text} onChange={(e)=>{setCurrentText(e)}}/>
          <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'10px'}}><Button color='secondary' variant='contained' onClick={submitText}>Save</Button></div>
        </div>)
    }
  }else{
    if(props.inline==true){return (<span style={{position:'relative', display:'inline-block'}} ref={main_container} dangerouslySetInnerHTML={{__html:(props.text_array[props.text]==undefined)?'... ... ...':placeholders(props.text_array[props.text], true)}}/>)}
    return(<span><Typography ref={main_container} variant={variant} color={props.color} style={{...style}}><span dangerouslySetInnerHTML={{__html:(props.text_array[props.text]==undefined)?'... ... ...':placeholders(props.text_array[props.text])}} /></Typography></span>);
  }
}




export default connect(ss,dd)(Explanation_text);
function ss(state){
  return{
    me:state.account.me,
    text_array:state.account.text,
    rerender:state.account.rerender
  }
}

function dd(dispatch){
  return{
    getAccountText:(info)=>{dispatch({type:'REQUEST_INDEX_ACCOUNT_TEXT'})},
    changeAdminText:(info)=>{dispatch({type:'REQUEST_UPDATE_ACCOUNT_TEXT', payload:info})}
  }
}
